import React from 'react';
import './App.css';
import Home from './components/Home';
import Ponuka from './components/Ponuka';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Strkopiesky from './components/Strkopiesky';
import Kamenivo from './components/Kamenivo';
import Piesok from './components/Piesok';
import Okrasny from './components/Okrasny';
import 'animate.css';
import ContactTab from './components/ContactTab';
import Doprava from './components/Doprava';
import Gdpr from './components/Gdpr';
import NotFound from './components/NotFound';
import FloatingContact from './components/FloatingContact';
import CerpaciaStanica from './components/CerpaciaStanica';
import SplitLanding from './components/SplitLanding';


const router = createBrowserRouter([
  { path: '/', element: <SplitLanding /> },
  { path: '/stavebniny', element: <Home /> },
  { path: '/ponuka', element: <Ponuka /> },
  { path: 'ponuka/strkopiesky', element: <Strkopiesky /> },
  { path: 'ponuka/kamenivo', element: <Kamenivo /> },
  { path: 'ponuka/piesok', element: <Piesok /> },
  { path: 'ponuka/okrasny', element: <Okrasny />},
  { path: '/contact', element: <ContactTab />},
  { path: '/doprava', element: <Doprava />},
  { path: '/gdpr', element: <Gdpr /> },
  { path: '/cerpacia-stanica', element: <CerpaciaStanica /> },
  { path: '*', element: <NotFound /> },
])

function App() {
  return (
    <>
      <RouterProvider router={router} />
      <FloatingContact />
    </>
  );
}

export default App;
